<template>
  <div>
    <div class="page-title">정기상담</div>
    <mdb-row>
      <mdb-col md="2">
        <student-list :training="training" v-model="student"/>
      </mdb-col>
      <mdb-col md="10">
        <counsel v-if="student" :training="training" :student="student"
          :counseler="counseler" />
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import RegularCounsel from '@/models/RegularCounsel'
import StudentList from '../../components/common/StudentList.vue';
import Counsel from '../../components/counsel/Counsel.vue';
export default {
  name: 'RegularCounselPage',
  components: { StudentList, Counsel },
  props: ['training'],
  data: () => ({
    student: null // 학생 리스트
  }),
  computed: {
    ...mapState('auth', ['profile']),
    counseler () {
      if (!this.profile) return {}
      return { _id: this.profile._id, name: this.profile.name }
    }
  },
  methods: {
    async load () {
      this.counsels = await RegularCounsel.list({ training: this._id })
    }
  },
  watch: {
    training: 'load'
  },
  created () {
    this.load()
  }
}
</script>
